import styled from 'styled-components';

const shouldForwardProp = prop => !['size'].includes(prop);

const ItemSelectionStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .itemCard {
    padding: 16px;
    background: var(--GrayScale-100);
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 16px;
    width: 100%;
  }

  .itemCardBody {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .itemCardItemLine {
    width: 100%;
    height: 1px;
    border-top: 1px dashed var(--GrayScale-600);
  }

  .itemCardFooter {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export default ItemSelectionStyled;
